import axios from "axios";
import $ from "jquery";

const state = {
  blogStatistics: {},
  blogPost: {},
  publishedBlogPosts: [],
  unpublishedBlogPosts: [],
};

const getters = {
  blogStatistics(state) {
    return state.blogStatistics;
  },

  blogPost(state) {
    return state.blogPost;
  },

  publishedBlogPosts(state) {
    return state.publishedBlogPosts;
  },

  unpublishedBlogPosts(state) {
    return state.unpublishedBlogPosts;
  },
};

const mutations = {
  setBlogStatistics(state, statistics) {
    state.blogStatistics = statistics;
  },

  setBlogPost(state, post) {
    state.blogPost = post;
  },

  setPublishedBlogPosts(state, posts) {
    state.publishedBlogPosts = posts;
  },

  setUnpublishedBlogPosts(state, posts) {
    state.unpublishedBlogPosts = posts;
  },

  deletePublishedBlogPost(state, id) {
    let index = state.publishedBlogPosts.findIndex((p) => p.id == id);
    state.publishedBlogPosts.splice(index, 1);
  },

  deleteUnpublishedBlogPost(state, id) {
    let index = state.unpublishedBlogPosts.findIndex((p) => p.id == id);
    state.unpublishedBlogPosts.splice(index, 1);
  },
};

const actions = {
  async fetchBlogStatistics({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/blog-post/statistics`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setBlogStatistics", res.data);
      });
  },

  async fetchBlogPost({ commit, rootState }, id) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/blog-post/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setBlogPost", res.data);
      });
  },

  async fetchPublishedBlogPosts({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/blog-post/published`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setPublishedBlogPosts", res.data);
      });
  },

  async fetchUnpublishedBlogPosts({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/blog-post/unpublished`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setUnpublishedBlogPosts", res.data);
      });
  },

  async publishBlogPost({ commit, dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/blog-post/publish/update?id=${data.id}&publish=${data.publish}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        dispatch("hideSpinnerLoading", null, { root: true });

        if (data.publish) {
          $.alert("post published successfull");
          commit("deleteUnpublishedBlogPost", data.id);
        } else {
          $.alert("post unpublished successfull");
          commit("deletePublishedBlogPost", data.id);
        }
      });
  },

  async createBlogPost({ rootState }, post) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/blog-post/create`, post, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updateBlogPost({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/blog-post/update/${data.id}`, data.post, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async deleteBlogPost({ dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/blog-post/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("post deleted successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async uploadBlogPostPhoto({ rootState }, formData) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    return await axios.post(`${apiUrl}/blog-post/photo/upload`, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async deleteBlogPostPhoto({ rootState }, data) {
    const accessToken = rootState.authStore.token;
    const apiUrl = process.env.VUE_APP_API_URL;

    await axios
      .delete(`${apiUrl}/blog-post/photo/delete`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: data,
      })
      .then(() => {
        $.alert("Image deleted !");
      });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
